import { Translate } from "./Tranlate";

let lang = localStorage.getItem("FMLang") || "en";
export const months = [
	"January",
	"February",
	"March",
	"April",
	"May",
	"June",
	"July",
	"August",
	"September",
	"October",
	"November",
	"December",
];
export const daysOptions = [
	{ label: "Saturday", value: 1 },
	{ label: "Sunday", value: 2 },
	{ label: "Monday", value: 3 },
	{ label: "Tuesday", value: 4 },
	{ label: "Wednesday", value: 5 },
	{ label: "Thursday", value: 6 },
	{ label: "Friday", value: 7 },
];
export const daysValuesOptions = [
	{ label: "Saturday", value: "SAT" },
	{ label: "Sunday", value: "SUN" },
	{ label: "Monday", value: "MON" },
	{ label: "Tuesday", value: "TUE" },
	{ label: "Wednesday", value: "WED" },
	{ label: "Thursday", value: "THU" },
	{ label: "Friday", value: "FRI" },
];
export const subjectsOptions = [
	{ label: "Kuwait", value: "KWT" },
	{ label: "British", value: "BRITISH" },
	{ label: "American", value: "AMERICAN" },
];
export const gradesOptions = [
	{ label: 1, value: 1 },
	{ label: 2, value: 2 },
	{ label: 3, value: 3 },
	{ label: 4, value: 4 },
	{ label: 5, value: 5 },
	{ label: 6, value: 6 },
	{ label: 7, value: 7 },
	{ label: 8, value: 8 },
	{ label: 9, value: 9 },
	{ label: 10, value: 10 },
	{ label: 11, value: 11 },
	{ label: 12, value: 12 },
];
export const educationTypeOptions = [
	{ label: "Kuwait", value: "KWT" },
	{ label: "British", value: "BRITISH" },
	{ label: "American", value: "AMERICAN" },
];
export const genderOptions = [
	{ label: Translate[lang].male, value: "male" },
	{ label: Translate[lang].female, value: "female" },
];
export const gendersUpOptions = [
	{ label: Translate[lang].male, value: "MALE" },
	{ label: Translate[lang].female, value: "FEMALE" },
	{ label: Translate[lang].mixed, value: "MIXED" },
];
export const gendersOptions = [
	{ label: Translate[lang].boy, value: "boy" },
	{ label: Translate[lang].girl, value: "girl" },
	{ label: Translate[lang].mixed, value: "mixed" },
];
export const ageGroupOptions = [
	{ label: "3-5", value: "THREE_TO_FIVE" },
	{ label: "6-8", value: "SIX_TO_EIGHT" },
	{ label: "9-12", value: "NINE_TO_TWELVE" },
];
export const AcceptedYearsOptions = Array.from(
	{ length: 2031 - 2000 },
	(_, i) => {
		const year = 2000 + i;
		return { label: year.toString(), value: year };
	}
);

export const degreeOptions = [
	{ label: Translate[lang].bachelors, value: "BACHELORS" },
	{ label: Translate[lang].master, value: "MASTERS" },
	{ label: Translate[lang].phd, value: "PHD" },
	{ label: Translate[lang].diploma, value: "DIPLOMA" },
	{ label: Translate[lang].high_school, value: "HIGH_SCHOOL" },
	{ label: Translate[lang].associate, value: "ASSOCIATE" },
	{ label: Translate[lang].other, value: "OTHER" },
];

export const convertDate = (date) =>
	new Date(`${date}T00:00:00Z`).toISOString();

/** Fixed floor list, 1 → 10. */
export const floorsOptions = Array.from({ length: 10 }, (_, i) => ({
	label: i + 1,
	value: i + 1,
}));

export const carColors = [
	// Standard Colors
	{ label: "Black", value: "black" },
	{ label: "White", value: "white" },
	{ label: "Silver", value: "silver" },
	{ label: "Gray", value: "gray" },
	{ label: "Red", value: "red" },
	{ label: "Blue", value: "blue" },
	{ label: "Green", value: "green" },
	{ label: "Yellow", value: "yellow" },
	{ label: "Orange", value: "orange" },
	{ label: "Brown", value: "brown" },
	{ label: "Beige", value: "beige" },
	{ label: "Gold", value: "gold" },
	{ label: "Purple", value: "purple" },
	{ label: "Maroon", value: "maroon" },
	{ label: "Pink", value: "pink" },

	// Metallic Finishes
	{ label: "Metallic Black", value: "metallic_black" },
	{ label: "Metallic Silver", value: "metallic_silver" },
	{ label: "Metallic Gray", value: "metallic_gray" },
	{ label: "Metallic Blue", value: "metallic_blue" },
	{ label: "Metallic Red", value: "metallic_red" },
	{ label: "Metallic Green", value: "metallic_green" },
	{ label: "Metallic Bronze", value: "metallic_bronze" },
	{ label: "Metallic Gold", value: "metallic_gold" },

	// Matte Finishes
	{ label: "Matte Black", value: "matte_black" },
	{ label: "Matte Gray", value: "matte_gray" },
	{ label: "Matte Blue", value: "matte_blue" },
	{ label: "Matte Red", value: "matte_red" },
	{ label: "Matte Green", value: "matte_green" },
	{ label: "Matte White", value: "matte_white" },

	// Custom / Specialty Finishes
	{ label: "Pearl White", value: "pearl_white" },
	{ label: "Pearl Black", value: "pearl_black" },
	{ label: "Candy Red", value: "candy_red" },
	{ label: "Chrome", value: "chrome" },
	{ label: "Satin Black", value: "satin_black" },
	{ label: "Color Shift (Chameleon)", value: "chameleon" },
	{ label: "Carbon Fiber Look", value: "carbon_fiber" },
	{ label: "Frozen Blue", value: "frozen_blue" },
	{ label: "Iridescent", value: "iridescent" },
];
